import { useCallback, useEffect, useState } from 'react';
export function useModal(onClose) {
    const [isOpen, setIsOpen] = useState(false);
    const [modalId, setModalId] = useState(null);
    const openModal = useCallback((id) => {
        setIsOpen(true);
        setModalId(id ?? null);
    }, []);
    const closeModal = useCallback(() => {
        setIsOpen(false);
        setModalId(null);
        onClose && onClose();
    }, [onClose]);
    const toggleModal = useCallback(() => {
        if (isOpen) {
            closeModal();
        }
        else {
            openModal();
        }
    }, [isOpen, openModal, closeModal]);
    useEffect(() => {
        if (!isOpen)
            return;
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                closeModal();
            }
        };
        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isOpen, closeModal]);
    return {
        isOpen,
        openModal,
        closeModal,
        toggleModal,
        modalId,
    };
}
